import { avatarAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(avatarAnatomy.keys)

const sizes = {
  brandMd: definePartsStyle({
    container: {
      width: '40px',
      height: '40px',
      border: '0px',
    },
    excessLabel: {
      width: '40px',
      height: '40px',
    },
  }),
}

export const avatarTheme = defineMultiStyleConfig({ sizes })
